import React, { useContext, useEffect } from "react";
import * as Contexts from "../../contexts";
import { config, Translater } from "../../config";
import { useLocation, useParams } from "react-router-dom";
import Link from "../../components/Buttons/Link";
import { useGetlanding } from "./utils";
import { Button } from "../../components/NewButton/NewButton";
import { useForm, FormProvider } from "react-hook-form";
import { TBanquetForm } from "./types";
import {
  CkeckBox,
  Descriptions,
  Gallery,
  MainPhoto,
  Terms,
} from "./components";
import { FormWrap } from "./styled";
import {
  createBanquetFormData,
  prepareInitialBanquetFormValues,
} from "./utils/setDefaultData";
import { useHttp } from "../../hooks";
import { Preloader } from "../../components/Page";
import { message } from "antd";

const LandingsBanquet = () => {
  const { token } = useContext(Contexts.AuthContext);
  const { language } = useContext(Contexts.LanguageContext);
  const { isActive } = useContext(Contexts.SidebarContext);

  const { pathname } = useLocation();
  const isBanquet = pathname.endsWith("/banquet");
  const basePath = isBanquet ? pathname.replace(/\/banquet$/, "") : pathname;
  const togglePath = isBanquet ? basePath : pathname + "/banquet";

  const { id } = useParams<{ id: string }>();
  const { landingData, mutate } = useGetlanding(id);
  const { request } = useHttp();
  const methods = useForm<TBanquetForm>({ mode: "onChange" });

  const onSubmit = async () => {
    const isValid = await methods.trigger();
    if (!isValid) {
      return;
    }
    const data = methods.getValues();
    try {
      const formData = await createBanquetFormData(data);
      await request(
        `${config.API}/landings/${landingData?._id}`,
        "PUT",
        formData,
        {
          Authorization: `Bearer ${token as string}`,
        }
      );
      mutate();
      message.success(
        language.slug === "en" ? "Successfully updated!" : "Успішно оновлено!"
      );
    } catch (error) {
      console.error(error);
      message.error(
        language.slug === "en"
          ? "An error occurred while saving."
          : "Сталася помилка під час збереження."
      );
    }
  };

  useEffect(() => {
    if (!landingData) return;

    prepareInitialBanquetFormValues(landingData).then((initialValues) => {
      methods.reset(initialValues);
    });
  }, [landingData]);

  if (methods.formState.isSubmitting) {
    return <Preloader />;
  }

  return (
    <FormProvider {...methods}>
      <FormWrap className={`wrapper ${isActive && "shorter"}`}>
        <Link
          title={Translater.Landings.Banquet.mainPage[language.slug]}
          linkTo={togglePath}
        />
        <div className="lending-header">
          <h1 className="title">
            {language.slug === "uk"
              ? landingData?.title[1]?.value
              : landingData?.title[0]?.value}
          </h1>
          <Button
            onClick={onSubmit}
            disabled={methods.formState.isSubmitting}
            buttonTitle={Translater.Buttons.update[language.slug]}
          />
        </div>

        <CkeckBox />
        <MainPhoto />
        <Gallery />
        <Descriptions />
        <Terms />
      </FormWrap>
    </FormProvider>
  );
};

export default LandingsBanquet;
